import defaultState from '../default';

const primary = (params) => defaultState.primary(params);

export default primary;
